import { RedeemRequest } from '../components/Account/RedeemRequest';
import { InviteRequest } from '../model/inviteRequest';
import { ResendEmailRequest } from '../model/resendEmailRequest';
import { api, apiNoAuth } from '../api';

export const inviteService = {
  getInviteDetails,
  redeemInvite,
  inviteUser,
  getAllActive,
  deleteInvite,
  resendInviteRequest,
};

/**
 * Get invite details by GUID
 * Uses apiNoAuth since this is typically called before authentication
 */
function getInviteDetails(inviteGuid: string) {
  return apiNoAuth.get(`/invite/get-invite/${inviteGuid}`);
}

/**
 * Redeem an invite code to create a new account
 * Uses apiNoAuth since user is not authenticated yet
 */
function redeemInvite(
  invitationCode: string,
  firstName: string,
  lastName: string,
  email: string,
  speciality: string,
  password: string,
  confirmPassword: string
) {
  const request: RedeemRequest = {
    invitationCode,
    firstName,
    lastName,
    email,
    speciality,
    password,
    confirmPassword,
  };
  return apiNoAuth.post('/invite/redeem', request);
}

/**
 * Invite a new user (requires authentication)
 */
function inviteUser(data: InviteRequest) {
  return api.post('/invite/invite-user', data);
}

/**
 * Get all active invites (requires authentication)
 */
function getAllActive() {
  return api.get('/invite/get-all-active');
}

/**
 * Delete an invite by GUID (requires authentication)
 */
function deleteInvite(inviteCodeGuid: string) {
  return api.post(`/invite/delete/${inviteCodeGuid}`);
}

/**
 * Resend invite email
 * Uses apiNoAuth since this might be called before authentication
 */
function resendInviteRequest(email: string) {
  const request: ResendEmailRequest = { email };
  return apiNoAuth.post('/invite/resend-invite-email', request);
}
